import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "flex mx-auto px-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "player" })
], -1)
const _hoisted_4 = { class: "flex-1" }
const _hoisted_5 = { class: "flex justify-center items-center" }
const _hoisted_6 = {
  class: "w-full max-w-xs flex flex-col py-5 px-8",
  action: ""
}
const _hoisted_7 = {
  class: "text-gray-700 font-bold py-2",
  for: ""
}
const _hoisted_8 = {
  class: "text-gray-700 font-bold py-2",
  for: ""
}
const _hoisted_9 = {
  class: "text-gray-700 font-bold py-2",
  for: ""
}
const _hoisted_10 = {
  class: "text-gray-700 font-bold py-2",
  for: ""
}
const _hoisted_11 = {
  class: "text-gray-700 font-bold py-2",
  for: ""
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "--", -1)
const _hoisted_13 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("form", _hoisted_6, [
            _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.labels_firstname) + " *: ", 1),
            _withDirectives(_createElementVNode("input", {
              class: "text-gray-700 shadow border rounded border-gray-300 focus:outline-none focus:shadow-outline py-1 px-3 mb-3",
              type: "text",
              placeholder: "",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.firstname) = $event))
            }, null, 512), [
              [_vModelText, _ctx.data.firstname]
            ]),
            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.labels_lastname) + ": ", 1),
            _withDirectives(_createElementVNode("input", {
              class: "text-gray-700 shadow border rounded border-gray-300 focus:outline-none focus:shadow-outline py-1 px-3 mb-3",
              type: "text",
              placeholder: "",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.lastname) = $event))
            }, null, 512), [
              [_vModelText, _ctx.data.lastname]
            ]),
            _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.labels_email) + " *: ", 1),
            _withDirectives(_createElementVNode("input", {
              class: "text-gray-700 shadow border rounded border-gray-300 mb-3 py-1 px-3 focus:outline-none focus:shadow-outline",
              type: "text",
              placeholder: "",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.data.email) = $event))
            }, null, 512), [
              [_vModelText, _ctx.data.email]
            ]),
            _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.labels_username) + " *: ", 1),
            _withDirectives(_createElementVNode("input", {
              class: "text-gray-700 shadow border rounded border-gray-300 mb-3 py-1 px-3 focus:outline-none focus:shadow-outline",
              type: "text",
              placeholder: "",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.data.username) = $event))
            }, null, 512), [
              [_vModelText, _ctx.data.username]
            ]),
            _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.labels_country) + ": ", 1),
            _withDirectives(_createElementVNode("select", {
              name: "delay",
              id: "delay",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.data.country) = $event)),
              style: {"font-size":"small"}
            }, [
              _hoisted_12,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: country.id,
                  value: country.id
                }, _toDisplayString(country.name), 9, _hoisted_13))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.data.country]
            ]),
            _createElementVNode("button", {
              class: "btn navbar-toggler btn-medium",
              type: "button",
              onClick: _cache[5] || (_cache[5] = async (e) => {await _ctx.save()})
            }, _toDisplayString(_ctx.actions_save), 1)
          ])
        ])
      ])
    ])
  ]))
}